import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { map } from 'lodash';

import { tGender } from '@models/User';
import { formatDate } from '@utils/datetime';
import { HealthQuote } from '@models/HealthQuote';
import { QuoteMember } from '@models/Quote';

interface RowItemProps {
  label: string;
  value?: string | number;
}

const RowItem = ({ label, value }: RowItemProps) => (
  <Row className="mb-2">
    <Col xs={7} sm={7} md={4}>
      {label}
    </Col>
    <Col xs="auto">:</Col>
    <Col>{value}</Col>
  </Row>
);

const MemberItem = ({
  name,
  nameKm,
  dob,
  age,
  gender,
  mobileNumber,
  personalCode,
  occupation,
  weight,
  height,
  email,
  address,
}: QuoteMember) => {
  const { t } = useTranslation();

  return (
    <Card className="mb-3">
      <Card.Header className="bg-white fs-5">{name}</Card.Header>
      <Card.Body>
        <RowItem label={t('user.nameKm')} value={nameKm} />
        <RowItem label={t('user.gender')} value={tGender(gender)} />
        <RowItem label={t('user.dob')} value={formatDate(dob)} />
        <RowItem label={t('user.age')} value={t('user.yearsOld', { age })} />
        <RowItem label={t('user.personalCode')} value={personalCode} />
        <RowItem label={t('user.occupation')} value={occupation} />
        <RowItem label={t('user.weight')} value={weight} />
        <RowItem label={t('user.height')} value={height} />
        <RowItem label={t('user.mobileNumber')} value={mobileNumber} />
        <RowItem label={t('user.email')} value={email} />
        <RowItem label={t('user.address')} value={address} />
      </Card.Body>
    </Card>
  );
};

const MemberCardBody = ({ membersArray }: Pick<HealthQuote, 'membersArray'>) => {
  const { t } = useTranslation();

  return (
    <Card.Body>
      <Card.Title>{t('healthQuoteReviewPage.memberDetailsTitle')}</Card.Title>
      {map(membersArray, (member, idx) => (
        <MemberItem key={`${member.memberType}.${idx}`} {...member} />
      ))}
    </Card.Body>
  );
};

export { MemberCardBody };
